import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@soundxyz/font-awesome/pro-regular-svg-icons/index.mjs';
import { EditionCover } from '@components/basics/EditionCover';
import { IconButton } from '@components/main-components/icon-buttons/IconButton';
import { StandardModal } from '@components/main-components/modals/StandardModal';

export const ViewEditionCoverModal = ({
  releaseCover,
  releaseTitle,
  closeCancelModal,
}: {
  releaseCover: string;
  releaseTitle: string;
  closeCancelModal: () => void;
}) => {
  const body = (
    <div className="h-full w-full overflow-hidden">
      <EditionCover
        releaseTitle={releaseTitle}
        releaseCover={releaseCover}
        imageSize={440}
        className="aspect-square h-full w-full rounded-md"
      />
    </div>
  );

  const header = (
    <div className="absolute -right-2.5 -top-2.5 z-above1">
      <IconButton
        variant="primary"
        icon={<FontAwesomeIcon icon={faXmark} size="lg" />}
        onClick={() => closeCancelModal()}
        className="bg-neutral200"
      />
    </div>
  );

  return (
    <StandardModal
      subHeader={header}
      body={body}
      bodyClassName="p-0 m-0 flex items-center justify-center"
      containerClassName="bg-transparent w-[343px] h-[343px] p-0 m-0 rounded-[14px] overflow-visible md:w-[440px] md:h-[440px]"
    />
  );
};
